import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroIndicadores extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Indicadores / Etiquetas / Chips';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro.processo.indicadores;
    }

    equals(valor1, valor2) {
        return valor1 && valor2 && valor1.codigo === valor2.codigo;
    }

    getDescricao(valor) {
        return valor ? `${valor.descricao} (Cód. ${valor.codigo})` : '';
    }
}
